
import ResearchTrainingCard from './ResearchTrainingCard'

const ResearchTrainingInner =()=>{
    return(
        <>
        <div className="card-wrap px-4">
            <h3 className="fw-700 fs-35 mb-5"> What’s Included</h3>
            <ResearchTrainingCard />

        </div>
       <div className="accordion-wrap  px-4">
        <h4 className="fw-700 fs-35 mb-42"> FAQs</h4>
         <div className="l-article l-accordion l-accordion4">
                <div className="mez slider">
                    <h3 className="l-accordion__title">
                        <span>Why Nature Masterclasses at HBKU?</span>
                    </h3>
                    <div className="l-accordion__content text">
                        <p className='fs-18'>
                            The Nature Masterclasses subscription reflects HBKU’s commitment to supporting excellence in research, publishing, and research integrity.The platform helps:
                        </p>
                        <ul className="mb-4">
                            <li>Improve the quality and visibility of HBKU research outputs</li>
                            <li>Strengthen researcher development across all colleges and institutes</li>
                            <li>Support early-career researchers and graduate students</li>
                            <li>Promote responsible, rigorous, and reproducible research</li>
                            <li>Equip faculty and research staff with advanced leadership and mentoring tools</li>
                        </ul>
                        <p className='fs-18'>This investment aligns with HBKU’s mission to advance high-impact research locally, regionally, and globally.</p>
                    </div>
                    
                    <h3 className="l-accordion__title">
                        <span>Who Can Benefit?</span>
                    </h3>
                    <div className="l-accordion__content">
                        <p className='fs-18'>Nature Masterclasses is available free of charge to the entire HBKU research community, including:</p>
                        <ul className="mb-4">
                            <li>Master’s and PhD students</li>
                            <li>Postdoctoral researchers</li>
                            <li>Early-career researchers</li>
                            <li>Faculty and scientists across all colleges and research institutes</li>
                            <li>Research support staff, lab members, and administrators involved in research activities</li>
                        </ul>
                        <p className='fs-18'>
                            Nature Masterclasses offers tailored learning for your needs.<br /> Whether you are preparing your first manuscript or supervising a research team.
                        </p>
                    </div>

                    <h3 className="l-accordion__title">
                        <span>How to Access Nature Masterclasses</span>
                    </h3>
                    <div className="l-accordion__content">
                        <ol className='number-list'>
                            <li>Visit the <a class="text-primary" href='https://masterclasses.nature.com/?gad_source=1&gad_campaignid=21751148803&gbraid=0AAAAAqb7NhpspDcm9rjq1bRp_FU5_hPyA&gclid=CjwKCAiA7LzLBhAgEiwAjMWzCH2G6EGvQ5DaO96uX2gE2pg_GzaG8wmIPGc3RcPq8cgE-p71Y68RVxoCyaIQAvD_BwE#nmo' target='_blank'>Nature Masterclasses platform</a> </li>
                            <li>Select <strong>"Register"</strong> or <strong>"Institutional Login"</strong></li>
                            <li>Search for and select <strong>“Hamad Bin Khalifa University (HBKU)”</strong> as your institution <strong>or</strong> register using your <strong>HBKU </strong>email address.</li>
                            <li>Complete the short registration form.</li>
                            <li>Check your email (including spam/junk) for a verification message.</li>
                            <li>Log in and begin exploring your courses at any time, from any device.</li>
                        </ol>

                    </div>

                    {/* <h3 className="l-accordion__title">
                        <span>Fees</span>
                    </h3>
                    <div className="l-accordion__content">
                        <p>Nature Masterclasses is available free of charge to the entire HBKU research community</p>
                    </div> */}
                    
                </div>
            </div>
            </div>
            </>
           
        
    )
}
export default ResearchTrainingInner